/**
 * Hoffmaster Product Detail Widget Handler
 * Handles gallery navigation and accordion functionality
 */

class HoffmasterProductDetailHandler extends elementorModules.frontend.handlers.Base {
	getDefaultSettings() {
		return {
			selectors: {
				mainImage: '#single-product-main-image',
				thumbnail: '.hm-single-product__product-gallery__thumbnails__button',
				prevButton: '.hm-single-product__product-gallery__arrows__prev',
				nextButton: '.hm-single-product__product-gallery__arrows__next',
				accordionHeader: '.hm-accordion__item__header',
				accordionItem: '.hm-accordion__item',
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings('selectors');
		return {
			$mainImage: this.$element.find(selectors.mainImage),
			$thumbnails: this.$element.find(selectors.thumbnail),
			$prevButton: this.$element.find(selectors.prevButton),
			$nextButton: this.$element.find(selectors.nextButton),
			$accordionHeaders: this.$element.find(selectors.accordionHeader),
		};
	}

	bindEvents() {
		// Initialize gallery if elements exist
		if (this.elements.$mainImage.length && this.elements.$thumbnails.length) {
			this.initGallery();
		}

		// Initialize accordion if elements exist
		if (this.elements.$accordionHeaders.length) {
			this.initAccordion();
		}
	}

	initGallery() {
		this.currentIndex = 0;
		this.images = [];

		// Extract image URLs from thumbnails
		this.elements.$thumbnails.each((i, btn) => {
			this.images.push(jQuery(btn).attr('data-image'));
		});

		// Thumbnail click handlers
		this.elements.$thumbnails.each((index, button) => {
			jQuery(button).on('click', () => {
				this.updateGallery(index);
			});
		});

		// Arrow navigation
		if (this.elements.$prevButton.length) {
			this.elements.$prevButton.on('click', () => {
				const newIndex = this.currentIndex === 0 ? this.images.length - 1 : this.currentIndex - 1;
				this.updateGallery(newIndex);
			});
		}

		if (this.elements.$nextButton.length) {
			this.elements.$nextButton.on('click', () => {
				const newIndex =
					this.currentIndex === this.images.length - 1 ? 0 : this.currentIndex + 1;
				this.updateGallery(newIndex);
			});
		}

		// Keyboard navigation
		jQuery(document).on('keydown', (e) => {
			if (e.key === 'ArrowLeft' && this.elements.$prevButton.length) {
				this.elements.$prevButton.trigger('click');
			} else if (e.key === 'ArrowRight' && this.elements.$nextButton.length) {
				this.elements.$nextButton.trigger('click');
			}
		});
	}

	updateGallery(index) {
		if (index < 0 || index >= this.images.length) {
			return;
		}

		this.currentIndex = index;
		this.elements.$mainImage.attr('src', this.images[this.currentIndex]);

		// Update active thumbnail
		this.elements.$thumbnails.each((i, btn) => {
			const $btn = jQuery(btn);
			if (i === this.currentIndex) {
				$btn.addClass('active');
			} else {
				$btn.removeClass('active');
			}
		});
	}

	initAccordion() {
		const selectors = this.getSettings('selectors');

		this.elements.$accordionHeaders.each((i, header) => {
			const $header = jQuery(header);

			$header.on('click', function () {
				const $accordionItem = jQuery(this).closest(selectors.accordionItem);
				const isActive = $accordionItem.hasClass('active');

				// Toggle active state
				if (isActive) {
					$accordionItem.removeClass('active');
					jQuery(this).attr('aria-expanded', 'false');
				} else {
					$accordionItem.addClass('active');
					jQuery(this).attr('aria-expanded', 'true');
				}
			});
		});
	}
}

jQuery(window).on('elementor/frontend/init', () => {
	elementorFrontend.elementsHandler.attachHandler(
		'hoffmaster_product_detail',
		HoffmasterProductDetailHandler
	);
});
